<style lang="less">
@import 'login.less';
</style>

<template>
  <div class="login">
    <div class="login-con">
      <Card icon="log-in" title="欢迎登录" :bordered="false">
        <div class="form-con">
          <login-form @on-success-valid="handleSubmit"></login-form>
          <p class="login-tip">登录即代表已阅读并同意 &nbsp;&nbsp;<span class="login-tip" @click="showPrivacy">隐私政策</span>&nbsp;&nbsp;<span
            class="login-tip"
            @click="showService">服务协议</span>
          </p>
        </div>
      </Card>
    </div>
    <privacy ref="privacy"></privacy>
    <service ref="service"></service>
  </div>
</template>

<script>
import LoginForm from '_c/login-form'
import { mapActions } from 'vuex'
import md5 from 'js-md5'

import privacy from '../protocol/privacy'
import service from '../protocol/service'

export default {
  components: {
    LoginForm, service, privacy
  },
  methods: {
    ...mapActions([
      'handleLogin',
      'getUserInfo'
    ]),
    handleSubmit ({ account, password }) {
      password = md5(password)
      this.handleLogin({ account, password }).then(res => {
        // 清理下session 防止数据存储的错误
        sessionStorage.clear()
        this.getUserInfo().then(res => {
          this.$router.push({
            name: this.$config.homeName
          })
        })
      })
    },
    showPrivacy () {
      this.$refs.privacy.openModel()
    },
    showService () {
      this.$refs.service.openModel()
    }
  }
}
</script>

<style>

</style>
